export default __webpack_public_path__ + "static/research_desk_collage-e39f2a164481ea09d7cbced04be9819b.jpg";